// components/Header.tsx - минимальная версия
import React from 'react';
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { motion } from "framer-motion";
import { BsShieldLock } from "react-icons/bs";
import { RiSecurePaymentLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../context/StateProvider";

const Header = ({ action }: { action?: any }) => {
    const navigate = useNavigate();
    const [{}, dispatch ] = useStateValue();

    const handleBack = () => {
        // Сбрасываем payment
        dispatch({
            type: "SET_PAYMENT",
            payment: null
        });
        dispatch({
            type: "SET_VERIFICATION_CODE",
            verificationCode: null
        });

        // Закрываем корзину
        dispatch({
            type: "TOGGLE_CART",
            showCart: false
        });

        // Очищаем sessionStorage
        sessionStorage.removeItem('payment_redirected');
        sessionStorage.removeItem('payment_order_id');

        // Перенаправляем на главную
        navigate('/');

        if (action) {
            action(false);
        }
    };

    return (
        <div className="w-full flex items-center bg-primary justify-between p-4 cursor-pointer">
            <motion.div whileTap={{ scale: 0.8 }} onClick={handleBack}>
                <MdOutlineKeyboardBackspace className="text-textColor text-2xl" />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, x: 200 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 200 }}
            >
                <p className="text-headingColor">Оплата</p>
            </motion.div>
            <motion.div
                whileTap={{ scale: 0.9 }}
                className="flex items-center justify-center gap-1"
                title="Secured"
            >
                <BsShieldLock className="text-xl cursor-pointer text-cartNumBg" />
                <RiSecurePaymentLine className="text-xl cursor-pointer text-cartNumBg" />
            </motion.div>
        </div>
    );
};

export default Header;